import firebase from "firebase";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

const config = {
  apiKey: "AIzaSyDvBYHu8XE_aLwExgK2amGaBU3bl7y0O34",
  authDomain: "main-page-8e1ef.firebaseapp.com",
  databaseURL: "https://main-page-8e1ef.firebaseio.com",
  projectId: "main-page-8e1ef",
  storageBucket: "main-page-8e1ef.appspot.com",
  messagingSenderId: "486479705632",
};

export default firebase.initializeApp(config);
